import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

export const Container = styled.div`
  min-width: calc(100% - 88px);

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  h2 {
    font-size: 20px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  .container-fluid {
    max-width: 1460px;
  }

  .bg-white {
    border-radius: 8px;
  }

  .btn-refresh {
    background: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 4px;
    color: #5e5e5e;
    font-size: 13px;
    font-weight: 500;
    padding: 8px 16px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: #e9ecef;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const FormWrapper = styled.div`
  .select-type {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    color: #202020;
    background: #fff;
    appearance: none;
    cursor: pointer;

    &:focus {
      border-color: #ff6900;
    }
  }

  label {
    font-size: 14px;
    font-weight: 500;
    color: #5e5e5e;
    margin-bottom: 6px;
  }

  .btn-dispatch {
    background: #ff6900;
    border: none;
    border-radius: 4px;
    color: #fff;
    font-weight: 500;
    padding: 10px 24px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: #e05e00;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-cancel {
    background: #dc3545;
    border: none;
    border-radius: 4px;
    color: #fff;
    font-weight: 500;
    padding: 10px 24px;
    font-size: 14px;
    margin-left: 12px;

    &:hover {
      background: #c82333;
    }
  }

  .btn-edit-delivery-info {
    background: transparent;
    border: none;
    color: #ff6900;
    font-weight: 500;
    font-size: 13px;
    padding: 0;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ProgressWrapper = styled.div`
  .progress-bar-container {
    width: 100%;
    height: 24px;
    background: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
  }

  .progress-bar-fill {
    height: 100%;
    background: #ff6900;
    transition: width 0.3s ease;
    border-radius: 4px;
  }

  .progress-info {
    font-size: 14px;
    color: #5e5e5e;
    margin-top: 8px;

    .sent {
      color: #00b15c;
      font-weight: 500;
    }

    .failed {
      color: #dc3545;
      font-weight: 500;
    }
  }

  .progress-email {
    font-size: 12px;
    color: #8c8c8c;
    margin-top: 4px;
  }
`;

export const ResultCard = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e1e1e1;

  h3 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 12px;
  }

  .result-stats {
    font-size: 14px;

    .sent {
      color: #00b15c;
      font-weight: 500;
    }

    .failed {
      color: #dc3545;
      font-weight: 500;
    }
  }

  .errors-list {
    margin-top: 12px;
    padding: 12px;
    background: #fff;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;

    summary {
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: #dc3545;
    }

    ul {
      list-style: none;
      padding: 0;
      margin-top: 8px;

      li {
        font-size: 12px;
        color: #5e5e5e;
        padding: 4px 0;
        border-bottom: 1px solid #f1f1f1;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
`;

export const ErrorCard = styled.div`
  background: #fff5f5;
  border: 1px solid #dc3545;
  border-radius: 8px;
  padding: 16px;
  color: #dc3545;
  font-size: 14px;
  font-weight: 500;
`;

export const DispatchesTable = styled.div`
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th {
      background: #f8f9fa;
      padding: 10px 12px;
      text-align: left;
      font-weight: 600;
      color: #5e5e5e;
      border-bottom: 2px solid #e1e1e1;
      white-space: nowrap;
    }

    td {
      padding: 10px 12px;
      border-bottom: 1px solid #f1f1f1;
      color: #202020;
    }

    tr:hover td {
      background: #fafafa;
    }

    .status-badge {
      display: inline-block;
      padding: 3px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
    }
  }
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .modal-content {
    border-radius: 8px;
    border: none;
  }

  .title {
    color: #000;
    font-size: 22px;
    font-weight: 500;
  }

  .modal-subtitle {
    color: #878787;
    font-size: 13px;
  }

  .quill {
    background: #fff;
  }

  .ql-toolbar.ql-snow {
    border-color: #ddd;
    border-radius: 4px 4px 0 0;
  }

  .ql-container.ql-snow {
    border-color: #ddd;
    border-radius: 0 0 4px 4px;
    font-size: 14px;
  }

  .ql-editor {
    min-height: 180px;
  }

  .btn-save {
    background: #ff6900;
    border: none;
    border-radius: 4px;
    color: #fff;
    font-weight: 500;
    padding: 10px 24px;
    font-size: 14px;
    transition: background 0.2s;

    &:hover:not(:disabled) {
      background: #e05e00;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-cancel-modal {
    background: transparent;
    border: 1px solid #ddd;
    border-radius: 4px;
    color: #5e5e5e;
    font-weight: 500;
    padding: 10px 24px;
    font-size: 14px;
    margin-right: 12px;

    &:hover {
      background: #f8f9fa;
    }
  }
`;
